export default __webpack_public_path__ + "static/media/data-filter.ea491b70.PNG";